// extracted by mini-css-extract-plugin
export default {"websiteValueCol":"styles_websiteValueCol__+gVWY"};